import { useState } from 'react';
import { sendPasswordResetEmail, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setInfo('');
    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
    } catch (err) {
      setError(err?.code === 'auth/too-many-requests'
        ? 'Çok fazla deneme yapıldı, lütfen biraz bekleyin.'
        : 'E-posta veya şifre hatalı.');
    }
    setLoading(false);
  };

  const handleReset = async () => {
    setError('');
    setInfo('');
    if (!email.trim()) { setError('Şifre sıfırlama için önce e-posta adresinizi yazın.'); return; }
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setInfo('Şifre sıfırlama bağlantısı e-posta adresinize gönderildi.');
    } catch {
      setError('Bağlantı gönderilemedi. E-posta adresini kontrol edin.');
    }
  };

  return (
    <div className="k-login">
      <div className="k-login-side">
        <img src="/kadihan-logo.jpg" alt="Kadıhan" className="k-login-logo" />
        <h1>Kadıhan<br />Yönetim Paneli</h1>
        <p>Siparişler, menü ve restoran ayarları tek yerde.</p>
      </div>
      <div className="k-login-main">
        <form className="k-login-card" onSubmit={handleLogin} noValidate>
          <img src="/kadihan-logo.jpg" alt="Kadıhan" className="k-login-card-logo" />
          <h2>Kadıhan yönetim paneli</h2>
          <p className="k-login-hint">Yönetici hesabınızla devam edin.</p>
          <label className="k-field">
            <span>E-posta</span>
            <input className="k-input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>
          <label className="k-field">
            <span>Şifre</span>
            <input className="k-input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </label>
          {error && <div className="k-alert error">{error}</div>}
          {info && <div className="k-alert ok">{info}</div>}
          <button type="submit" className="k-btn k-btn-primary k-btn-lg k-btn-block" disabled={loading}>
            {loading ? 'Giriş yapılıyor…' : 'Giriş yap'}
          </button>
          <button type="button" className="k-link" onClick={handleReset}>Şifremi unuttum</button>
        </form>
      </div>
    </div>
  );
}

export default Login;
